import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Compass } from "lucide-react";
import { EmptyState } from "@/components/ui";

/** Honest 404 — shown for any unknown route instead of a silent redirect to Home. */
export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-4 py-10">
      <EmptyState
        icon={<Compass className="size-8" />}
        title={t("notFound.title")}
        body={t("notFound.body")}
      />
      <Link
        to="/"
        className="text-(length:--text-sm) font-medium text-(--brand) hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--brand)"
      >
        {t("notFound.home")}
      </Link>
    </div>
  );
}
